import React from "react";

import ButtonRound from "../../button-action";
import Icons from "../../icons-helper";

import * as S from "./styles";
import { theme } from "../../../styles/theme";

import IProps from "./props";

const DocumentCard: React.FC<IProps> = ({
  docType,
  number,
  date,
  taker,
  status,
  value,
  actions,
}) => {
  const buttonConfig = [
    {
      title: "Detalhes",
      icon: {
        height: 20,
        width: 20,
        name: "information",
        color: theme.colors.green,
      },
      onClick: actions.detail,
      color: theme.colors.blue100,
    },
    {
      title: "Visualizar",
      icon: { height: 20, width: 20, name: "eye", color: theme.colors.green },
      onClick: actions.view,
      color: theme.colors.green,
      disabled: status === "PENDENTE",
    },
    {
      title: "Download",
      icon: {
        height: 20,
        width: 20,
        name: "download",
        color: theme.colors.primary,
      },
      onClick: actions.download,
      color: theme.colors.lightBlue,
      disabled: status === "PENDENTE",
    },
    {
      title: "Cancelar",
      icon: { height: 15, width: 15, name: "close", color: theme.colors.red },
      onClick: actions.cancel,
      color: theme.colors.red,
      disabled: status === "CANCELADO",
    },
  ];

  return (
    <S.Container>
      <S.Header>
        <S.HeadingInfo>
          <S.Title canceled={status === "CANCELADO"}>
            <strong>{docType}: </strong> {number}
          </S.Title>
          <S.Subtitle canceled={status === "CANCELADO"}>{value}</S.Subtitle>
        </S.HeadingInfo>
        <S.Actions>
          {buttonConfig.map((button) => (
            <ButtonRound
              key={button.title}
              title={button.title}
              disabled={button.disabled}
              backgroundColor={theme.colors.blue900}
              onClick={button.onClick}
              color={button.color}
            >
              <Icons
                height={button.icon.height}
                width={button.icon.width}
                name={button.icon.name}
                color={button.icon.color}
              />
            </ButtonRound>
          ))}
        </S.Actions>
      </S.Header>
      <S.Value canceled={status === "CANCELADO"}>{date}</S.Value>
      <S.Value canceled={status === "CANCELADO"}>{taker}</S.Value>
      <S.Value canceled={status === "CANCELADO"}>{status}</S.Value>
    </S.Container>
  );
};

export default DocumentCard;
